import { useDispatch } from "react-redux";
import { addproduct } from "../../redux/product/actions";
function ProductInput(){
  const dispatch = useDispatch();
  const submitHandler = (e) => {
    e.preventDefault();
    const name = e.target[0].value;
    const category = e.target[1].value;
    const img = e.target[2].value;
    const price = e.target[3].value;
    const qty = e.target[4].value;  
    dispatch(addproduct({name, category, img, price, qty}));
    e.target.reset();
    
  }
    return(
        <div>
        {/* Product Input Form */}
        <div className="formContainer">
          <h4 className="formTitle">Add New Product</h4>
          <form onSubmit={submitHandler} className="space-y-4 text-[#534F4F]" id="lws-addProductForm">
            {/* product name */}
            <div className="space-y-2">
              <label htmlFor="lws-inputName">Product Name</label>
              <input className="addProductInput" id="lws-inputName" type="text" required />
            </div>
             {/* product category */}
            <div className="space-y-2">
              <label htmlFor="lws-inputCategory">Category</label>
              <input className="addProductInput" id="lws-inputCategory" type="text" required />
            </div>
             {/* product image url */}
            <div className="space-y-2">
              <label htmlFor="lws-inputImage">Image Url</label>
              <input className="addProductInput" id="lws-inputImage" type="text" required />
            </div>
             {/* price & quantity container */}
            <div className="grid grid-cols-2 gap-8 pb-4">
               {/* price */}
              <div className="space-y-2">
                <label htmlFor="ws-inputPrice">Price</label>
                <input className="addProductInput" type="number" step="any" id="lws-inputPrice" required />
              </div>
               {/* quantity */}
              <div className="space-y-2">
                <label htmlFor="lws-inputQuantity">Quantity</label>
                <input className="addProductInput" type="number" id="lws-inputQuantity" required />
              </div>
            </div>
             {/* submit button */}
            <button type="submit" id="lws-inputSubmit" className="submit">Add Product</button>
          </form>
        </div>
         {/* Product Input Form Ends */}
      </div>
    );
}
export default ProductInput;